'use strict';

var CustomFieldsCtrl = function ($scope,
                                 $state,
                                 gettextCatalog,
                                 Notification,
                                 OfficeDA,
                                 ModalService,
                                 officeResolve) {
    this.showPremiumNotification = $scope.subscription.onlyBasicFunctions;
    this.scope_ = $scope;
    this.$state = $state;
    this.scope_.office = officeResolve;
    this.scope_.office.settings.customFields = this.scope_.office.settings.customFields || {
        'customer': [],
        'appointment': []
    };
    this._OfficeDA = OfficeDA;
    this.Notification_ = Notification;
    this.gettextCatalog = gettextCatalog;
    this._ModalService = ModalService;
};


/**
 * @param {object} field
 */
CustomFieldsCtrl.prototype.select = function (field, type, index) {
    if (type === 'customer') {
        this.$state.go('private.main.customFieldCustomer', {
            name: field.name,
        });
    } else {
        this.$state.go('private.main.customFieldAppointment', {
            name: field.name,
        });
    }
};


/**
 * @param {string} type
 */
CustomFieldsCtrl.prototype.add = function (type) {
    if (type === 'customer') {
        this.$state.go('private.main.customFieldCustomer', {
            name: 'new',
        });
    } else {
        this.$state.go('private.main.customFieldAppointment', {
            name: 'new',
        });
    }
};


/**
 * save custom fields
 */
CustomFieldsCtrl.prototype.save = function (type) {
    var self = this;

    this._OfficeDA
        .update(this.scope_.office)
        .then(() => {
            if (type === 'save' || !type) {
                self.Notification_.addSuccessMessage(self.gettextCatalog.getString('Custom field saved'));
            } else if (type === 'delete' || !type) {
                self.Notification_.addSuccessMessage(self.gettextCatalog.getString('Custom field removed'));
            }
        })
        .catch(() => {
            self.Notification_.addErrorMessage(self.gettextCatalog.getString('Cant save custom field'));
        });
};

CustomFieldsCtrl.prototype.moveField = function (index, type, direction) {
    if (direction > 0) {
        if (index > 0) {
            this.scope_.office.settings.customFields[type].move(index, (index - 1));
        }
    } else {
        if (index < (this.scope_.office.settings.customFields[type].length - 1)) {
            this.scope_.office.settings.customFields[type].move(index, (index + 1));
        }
    }
    this.save();
};
module.exports = CustomFieldsCtrl;
